export const ENTITIES = {
  SUPPLIER: 'Supplier',
  FACTORY: 'Factory',
  PRODUCT: 'Product',
};
export const ENTITY_DATA_KEY_MAPPING = {
  [ENTITIES.SUPPLIER]: 'suppliers',
  [ENTITIES.FACTORY]: 'factories',
  [ENTITIES.PRODUCT]: 'products',
};
